module.exports = __webpack_public_path__ + "img/Pellets-Herstellung.e857332.webp";